// extracted by mini-css-extract-plugin
export default {"link":"qD-z","disabled":"rD-z"};